import { render, staticRenderFns } from "./menu-search.vue?vue&type=template&id=be843b80"
import script from "./menu-search.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-search.vue?vue&type=script&setup=true&lang=js"
import style0 from "./menu-search.vue?vue&type=style&index=0&id=be843b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports